export default __webpack_public_path__ + "static/media/DANIEL-img.1170ce89.png";